<template>
    <div class="tab-content-wrap">

        <edit-switch :tab="selectedTab" :edit="editEnabled" :initialCondition="selectedTab == 3" v-on:toggleEdit="handleToggleEdit" />
        <div class="tab-content overflow-hidden">
            <div class="item-content">
                <div class="access-sg text clearfix">
                    <div class="row">
                        <div class="col-12">
                            <div class="d-flex justify-content-between">
                                <page-title title="Coupons" />
                                <div class="d-flex justify-content-end" v-if="editEnabled">
                                    <button class="btn btn-add-alt text-white" v-on:click="$emit('handleShowAddCoupons')">CREATE COUPONS</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 d-flex pb-4">
                            <div class="card h-100 w-100" style="border-radius: 0 0 10px 10px; min-height: 200px;">
                                <table class="table" v-if="course.courseCoupons">
                                    <thead>
                                        <tr>
                                            <th>
                                                ID
                                            </th>
                                            <th>
                                                Create Date
                                            </th>
                                            <th>
                                                Code
                                            </th>
                                            <th>
                                                Redeemer
                                            </th>
                                            <th>
                                                Redeem Date
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="course.courseCoupons.length < 1">
                                            <td colspan="5" class="text-center">
                                                No coupons yet
                                            </td>
                                        </tr>
                                        <tr v-for="coupon in course.courseCoupons">
                                            <td>{{ coupon.id }}</td>
                                            <td>{{ coupon.createTimestamp }}</td>
                                            <td>{{ coupon.code }}</td>
                                            <td>
                                                <span v-if="coupon.redeemerUser">
                                                    {{ coupon.redeemerUser.id }} - {{ coupon.redeemerUser.email }}<br />
                                                    {{ coupon.redeemerUser.firstName }} {{ coupon.redeemerUser.surname }}
                                                </span>
                                                <span v-else>
                                                    "None"
                                                </span>
                                            </td>
                                            <td>
                                                {{ coupon.redeemTimestamp ? coupon.redeemTimestamp : "Not redeemed" }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="title text-center" style="margin-top: 80px;" v-if="!course.courseCoupons">
                                    No coupons yet
                                </div>
<!--                                <conditional-text :condition="!course.courseCoupons" text="No coupons yet!" />-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CouponsPage",
        props: ["tab", "edit", "initialCourse", "initialCouponCount", "discountPercentage"],
        data() {
            return {
                selectedTab: this.tab,
                editEnabled: this.edit,
                course: this.initialCourse,
                couponCount: this.initialCouponCount,
                couponDiscountPercentage: this.discountPercentage,
            }
        },
        watch: {
            tab: function (newVal, oldVal) {
                this.selectedTab = newVal;
            },
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
            initialCourse: function (newVal, oldVal) {
                this.course = newVal;
            },
            initialCouponCount: function (newVal, oldVal) {
                this.couponCount = newVal;
            },
            discountPercentage: function (newVal, oldVal) {
                this.couponDiscountPercentage = newVal;
            }
        },
        methods: {
            handleToggleEdit() {
                this.$emit("toggleEdit");
            }
        },
        mounted() {
            //console.log("Coupons page loaded");
        }
    }
</script>